/** День (локальний час браузера), коли користувач сховав смугу боргу на Обігу. */
export const OBIG_PURCHASE_DEBT_DISMISS_DAY_KEY = "obigPurchaseDebtDismissedYmd";

export function getLocalYmd() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function isPurchaseDebtBarDismissedToday() {
    if (typeof localStorage === "undefined") return false;
    try {
        const stored = localStorage.getItem(OBIG_PURCHASE_DEBT_DISMISS_DAY_KEY);
        return stored === getLocalYmd();
    } catch {
        return false;
    }
}

export function dismissPurchaseDebtBarForToday() {
    if (typeof localStorage === "undefined") return;
    try {
        localStorage.setItem(OBIG_PURCHASE_DEBT_DISMISS_DAY_KEY, getLocalYmd());
    } catch {
        /* ignore */
    }
}
